import UserSaga from "./UserAPI";
import ArsSaga from "./ArsAPI";
import PassSaga from "./PassAPI";
import ContractSaga from "./ContractAPI";
import ChangeCmsSaga from "./ChangeCmsAPI";
import EkycSaga from "./EkycAPI";

function sagaConfigure(sagaMiddleware) {
    sagaMiddleware.run(UserSaga);
    sagaMiddleware.run(ArsSaga);
    sagaMiddleware.run(PassSaga);
    sagaMiddleware.run(ContractSaga);
    sagaMiddleware.run(ChangeCmsSaga);
    sagaMiddleware.run(EkycSaga);
}

export default sagaConfigure;
